
import axios from 'axios'
import baseurl from "@/utils/baseurl";
import { ElNotification } from 'element-plus'
var qs = require("qs");
// 域名地址
axios.defaults.baseURL = baseurl.baseurl;
//  REQUEST 请求异常拦截
axios.interceptors.request.use(config => {
  // console.log(config, 'config')
  //判断是不是获取版权年限
  config.headers = {
    //请求头自定义
    "Content-Type": "application/x-www-form-urlencoded",
    // token: window.localStorage.getItem('token') ? JSON.parse(window.localStorage.getItem('token') || '') : '',
  };
  // console.log(config.data,"config.data")
  // config.data = qs.stringify(config.data) // 转为formdata数据格式
  config.timeout = 30000;
  return config;
}, err => {
  // 错误处理
  console.log('请求超时!')
  return Promise.resolve(err);
});
//  RESPONSE 响应异常拦截
axios.interceptors.response.use(result => {
  // console.log(result, 'result123')
  // return
  //登录失效，进入登录页
  if (result.data.code == 401) {
    window.localStorage.clear()
    // 延迟 1 秒显示
    setTimeout(() => {
      ElNotification({
        title: '授权已过期',
        message: '请重新进行登录',
        type: 'warning',
      })
    }, 1000)
    return data;
  } else if (result.status == 200) {
    var data = result.data
    return data
  }

  // };

  return result;
},
  error => {
    if (error.response) {
      console.log("请求错误", error.response.status);
      switch (error.response.status) {
        case 401:
          window.localStorage.clear()
          break;
        case 404:
          console.log('接口不存在');
          break;
        case 500:
          console.log('服务器错误');
          break;
        case 403:
          break;
        case 503:
          // window.localStorage.clear()
          // window.location.href = '/login'
          break;
      }
    }
    return Promise.reject(error); // 返回接口返回的错误信息
  });

// 接口域名
export const url = axios.defaults.baseURL;

// POST 方法封装 (处理参数与文件上传)
export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    // data: params,
    params: params
  });
}
//  GET 方法封装
export const getRequest = (url, params) => {
  return axios({
    method: 'get',
    url: url,
    // data: params,
    params: params
  });
}